import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { chipSx } from './SizeStatusChips';
import { KEY_STATUSES } from './constants';
import { formatDate } from '../../../utils/buyerInsightsDates';
import { sizeStatusLabel } from '../../../utils/buyerInsightsFormat';

// "Size key · status on {End}" — only in All products (spec §2.1).
const SizeKey = ({ end, statuses = KEY_STATUSES }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1.5, mb: 1.5 }}>
    <Typography variant="caption" color="text.secondary">
      Size key · status on {formatDate(end)}
    </Typography>
    {statuses.map((status) => (
      <Box key={status} sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
        <Chip label="M" size="small" variant="outlined" sx={{ fontSize: '0.75rem', height: 22, ...chipSx(status) }} />
        <Typography variant="caption" color="text.secondary">
          {sizeStatusLabel(status)}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default SizeKey;
